// extracted by mini-css-extract-plugin
export default {"root":"Meeting_root__kGRuz","header":"Meeting_header__8oi-y","body":"Meeting_body__bFy9A","section":"Meeting_section__WYkJy","infoItem":"Meeting_infoItem__WOQQU"};